import { z } from 'zod';

export const PricingZod = z.union([z.literal('DirectInvoicing'), z.literal('Coupon'), z.literal('NoPromoCode')]);

export type Pricing = z.infer<typeof PricingZod>;
